var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CreateSpaceTagRepository, DeleteSpaceTagRepository, QuerySpaceTagsRepository, UpdateSpaceTagRepository } from './space-tag-repository.interface';
import { SpaceTagsModel } from '../model/space-tags-model';
import { ToastError } from '@/infrastructure/utils/toast-error';
import { I18nService } from '@/services/i18n-service';
// import { TAG_MAX_TOTAL_SIZE } from '../constants';
import { isValidSpecial } from '@patsnap-utils/validations/src';
let SpaceTagServiceImp = class SpaceTagServiceImp {
    constructor(_createSpaceTagRepository, _updateSpaceTagRepository, _querySpaceTagsRepository, _deleteSpaceTagRepository, _spaceTagsModel, _i18nService) {
        this._createSpaceTagRepository = _createSpaceTagRepository;
        this._updateSpaceTagRepository = _updateSpaceTagRepository;
        this._querySpaceTagsRepository = _querySpaceTagsRepository;
        this._deleteSpaceTagRepository = _deleteSpaceTagRepository;
        this._spaceTagsModel = _spaceTagsModel;
        this._i18nService = _i18nService;
    }
    async createSpaceTag(spaceTag) {
        this._validateTagNameLength(spaceTag.tagName);
        this._validateTagName(spaceTag.tagName);
        this._validateTagNameRule(spaceTag.tagName);
        this._validateMaxSize();
        const result = await this._createSpaceTagRepository.createSpaceTag(spaceTag);
        this._addSpaceTag(result);
        return result;
    }
    _validateTagName(tagName) {
        if (this._hasSameNameTag(tagName)) {
            throw new ToastError(this._i18nService.t('workspace.customFieldSelectAndEdit.existing'));
        }
    }
    _validateTagNameRule(tagName) {
        if (!isValidSpecial(tagName)) {
            throw new ToastError(this._i18nService.t('snapBusiness.customField.special'));
        }
    }
    _validateTagNameLength(tagName) {
        if (tagName.length > 20) {
            const message = this._i18nService.t('workspace.customFieldSelectAndEdit.upToTagNameLimit');
            throw new ToastError(message);
        }
    }
    _validateMaxSize() {
        if (this._isOverMaxSize()) {
            const message = this._i18nService.t('workspace.customFieldSelectAndEdit.upToTagLimit');
            throw new ToastError(message);
        }
    }
    _isOverMaxSize() {
        // return this._spaceTagsModel.modelData.length >= TAG_MAX_TOTAL_SIZE;
        return false;
    }
    _hasSameNameTag(tagName) {
        return this._spaceTagsModel.modelData.some((tag) => tag.tagName === tagName);
    }
    _addSpaceTag(spaceTag) {
        this._spaceTagsModel.update((spaceTags) => {
            return [...spaceTags, spaceTag];
        });
    }
    _updateSpaceTagOrNot(existingSpaceTag, updatedSpaceTag) {
        if (existingSpaceTag.tagId === updatedSpaceTag.tagId) {
            return updatedSpaceTag;
        }
        return existingSpaceTag;
    }
    _updateSpaceTag(spaceTags, spaceTag) {
        return spaceTags.map(existingSpaceTag => this._updateSpaceTagOrNot(existingSpaceTag, spaceTag));
    }
    async updateSpaceTag(spaceTag) {
        this._validateTagNameLength(spaceTag.tagName);
        this._validateTagName(spaceTag.tagName);
        this._validateTagNameRule(spaceTag.tagName);
        const result = await this._updateSpaceTagRepository.updateSpaceTag(spaceTag);
        this._spaceTagsModel.update(spaceTags => this._updateSpaceTag(spaceTags, result));
        return result;
    }
    async querySpaceTags(data) {
        const spaceTags = await this._querySpaceTagsRepository.querySpaceTags(data);
        this._spaceTagsModel.update(() => {
            return spaceTags;
        });
        return spaceTags;
    }
    _deleteSpaceTag(spaceTags, tagId) {
        return spaceTags.filter((spaceTag) => spaceTag.tagId !== tagId);
    }
    async deleteSpaceTag(data) {
        const bool = await this._deleteSpaceTagRepository.deleteSpaceTag(data);
        if (bool) {
            this._spaceTagsModel.update(spaceTags => this._deleteSpaceTag(spaceTags, data.tagId));
        }
        return bool;
    }
};
SpaceTagServiceImp = __decorate([
    injectable(),
    __param(0, inject(CreateSpaceTagRepository)),
    __param(1, inject(UpdateSpaceTagRepository)),
    __param(2, inject(QuerySpaceTagsRepository)),
    __param(3, inject(DeleteSpaceTagRepository)),
    __param(4, inject(SpaceTagsModel)),
    __param(5, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof CreateSpaceTagRepository !== "undefined" && CreateSpaceTagRepository) === "function" ? _a : Object, typeof (_b = typeof UpdateSpaceTagRepository !== "undefined" && UpdateSpaceTagRepository) === "function" ? _b : Object, typeof (_c = typeof QuerySpaceTagsRepository !== "undefined" && QuerySpaceTagsRepository) === "function" ? _c : Object, typeof (_d = typeof DeleteSpaceTagRepository !== "undefined" && DeleteSpaceTagRepository) === "function" ? _d : Object, typeof (_e = typeof SpaceTagsModel !== "undefined" && SpaceTagsModel) === "function" ? _e : Object, typeof (_f = typeof I18nService !== "undefined" && I18nService) === "function" ? _f : Object])
], SpaceTagServiceImp);
export { SpaceTagServiceImp };
